import { render, staticRenderFns } from "./UpgradeCompleted.vue?vue&type=template&id=485f2cb8&scoped=true&"
import script from "./UpgradeCompleted.vue?vue&type=script&lang=js&"
export * from "./UpgradeCompleted.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeCompleted.vue?vue&type=style&index=0&id=485f2cb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f2cb8",
  null
  
)

export default component.exports